import httpClient from '@/libs/http-client'
import { getAuthToken } from '@/libs/auth-helper'

export function commonBoardCode (params) {
  const url = '/api/common/code'
  return httpClient.post(url, params).then(response => {
    return response
  })
}
export function commonCode (params) {
  const url = '/api/common/gameCodes'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function gameGroupCodes (params) {
  const url = '/api/common/gameGroupCodes'
  return httpClient.post(url, params).then(response => {
    return response
  })
}

export function coinSymbol (params) {
  const appkey = process.env.VUE_APP_API_KEY
  const token = getAuthToken()

  const url = `/api/coin?symbol=${params}`
  const headers = {
    Authorization: appkey,
    token: token
  }

  return httpClient.get(url, headers).then(response => {
    return response
  })
}
